export default __webpack_public_path__ + "static/reclame-aqui-mobile-5680af02e7dfa613577da4245a1181a3.svg";